import "./blurb.css";
import { SCHOOL_PROGRAM_PDF } from "../../../Constants/mediaLinks";

export default function Blurb() {
  return (
    <>
      <div className="after-school-blurb">
        <p className="black-text-clip">
          At BWC we offer an enriching afterschool program focused on sports and
          physical activity. Our program is designed to provide children with a
          fun, safe, and supportive environment to explore various sports,
          develop new skills, and build lasting friendships.
        </p>
        <button
          className="sp-blurb-btn"
          style={{ backgroundColor: "#C7822D" }}
          onClick={() => window.open(SCHOOL_PROGRAM_PDF, "_blank")}
        >
          Download School Programs PDF
        </button>
      </div>
    </>
  );
}
